'use no memo';
import type { FC } from 'react';
import React from 'react';
import { css, styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import {
	ContentIcon,
	QuickActions,
	Subtitle,
	LastAction,
	StatusLozenge,
	Title,
	PageLink,
	PageCardContainer,
} from '../Items/index.ts';

const listCardStyles = css({
	minWidth: '0',
	padding: `${token('space.100')} ${token('space.200')}`,
	display: 'flex',
	alignItems: 'center',
});

const titleContainerStyles = css({
	display: 'flex',
	alignItems: 'center',
});

const contentIconStyles = css({
	alignSelf: 'flex-start',
	margin: `${token('space.025')} ${token('space.200')} 0 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MainContentContainer = styled.div({
	alignSelf: 'flex-start',
	flex: '1 1 0px',
	minWidth: '300px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TitleText = styled.div({
	marginRight: token('space.100'),
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

const lastActionContainerStyles = css({
	minWidth: '100px',
	flex: '0 1 220px',
	textAlign: 'right',
});

export const ListView: FC = () => {
	// ⚠️ WARNING: Do you need to add conditional logic? Please refer to README#Views ⚠️
	return (
		<PageCardContainer isListitem>
			<PageLink />
			<div data-testid="page-card-list-view" css={[listCardStyles]}>
				<div css={[contentIconStyles]}>
					<ContentIcon />
				</div>
				<MainContentContainer>
					<div css={[titleContainerStyles]}>
						<TitleText>
							<Title singleLine />
						</TitleText>
						<StatusLozenge />
					</div>
					<Subtitle />
				</MainContentContainer>

				<QuickActions hidden />
				<div css={lastActionContainerStyles}>
					<LastAction appearance="list" />
				</div>
			</div>
		</PageCardContainer>
	);
};
